export const EUR = "EUR";
export const VXC = "VXC";
